import styled from '../../../utils/styled';
import {Theme} from '../../../theme';
import {SelectionControlStateProps} from '../../SelectionControl';

interface CheckboxVisualProps extends SelectionControlStateProps {
  indeterminate?: boolean;
}

type WithTheme = CheckboxVisualProps & {theme: Theme};

const checkedRules = ({checked, theme}: WithTheme) => {
  if (checked) {
    return {
      backgroundColor: theme.color.primary,
      borderColor: theme.color.primary,
      '::after': {
        transform: 'rotate(45deg) scale(1)',
        transition: 'all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s'
      }
    };
  }
  return {};
};

const hoveredAndFocusedRules = ({hovered, focused, theme}: WithTheme) => ({
  borderColor: hovered || focused ? theme.color.primary : undefined
});

const indeterminateRules = ({indeterminate, theme}: WithTheme) => {
  if (indeterminate) {
    return {
      backgroundColor: theme.color.primary,
      borderColor: theme.color.primary,
      '::after': {
        content: `''`,
        transform: 'scale(1)',
        left: 2.42857143,
        top: 5.92857143,
        width: 9.14285714,
        height: 1.14285714
      }
    };
  }
  return {};
};

const disabledRules = ({disabled}: WithTheme) => {
  if (disabled) {
    return {
      backgroundColor: '#f5f5f5',
      borderColor: '#d9d9d9',
      '::after': {
        borderColor: 'rgba(0,0,0,0.25)'
      }
    };
  }
  return {};
};

export default styled('span')<CheckboxVisualProps>(
  {
    boxSizing: 'border-box',
    display: 'block',
    position: 'relative',
    background: '#fff',
    border: '1px solid #d9d9d9',
    borderRadius: 2,
    width: 16,
    height: 16,
    zIndex: 1,
    transition: 'all .3s',
    '::after': {
      boxSizing: 'border-box',
      transform: 'rotate(45deg) scale(0)',
      position: 'absolute',
      left: 4.57142857,
      top: 1.14285714,
      width: 5.71428571,
      height: 9.14285714,
      display: 'table',
      border: '2px solid #fff',
      borderTop: 0,
      borderLeft: 0,
      content: `''`,
      transition: 'all .1s cubic-bezier(0.71, -0.46, 0.88, 0.6)'
    }
  },
  checkedRules,
  hoveredAndFocusedRules,
  indeterminateRules,
  disabledRules
);



// WEBPACK FOOTER //
// ./src/components/Checkbox/private/CheckboxVisual.tsx